import React, { useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Avatar from '@material-ui/core/Avatar';
import Toolbar from '@material-ui/core/Toolbar';
import { Grid, Typography, CircularProgress, Button } from '@material-ui/core/';
import ButtonMUI from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { ExcelIcon } from '../../../core/themes/icons/ExcelIcon';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitleWithCloseButton from '../../../core/components/DialogTitleWithCloseButton';
import FileInput from '../../../core/components/forked/input/FileInput';
import FileField from '../../../core/components/forked/field/FileField';
import { FormDataConsumer, refreshView, Loading } from 'react-admin';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { useNotify } from 'ra-core';
import { getIcError } from '../../../core/providers/utils';
import { saveAs } from 'file-saver';
import useNotifyServerError from '../../../core/hooks/useNotifyServerError';
import ErrorIcon from '@material-ui/icons/Error';
import CustomSimpleForm from '../../../core/components/form/CustomSimpleForm';
import InvestorTagApi from '../../../core/apis/InvestorTagApi';

const styles = {
  avatar: {
    marginRight: 0,
    marginLeft: 0,
    verticalAlign: 'middle',
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    height: '36px',
    width: '36px',
    color: '#757575'
  },
  errorIcon: {
    marginRight: 0,
    marginLeft: 0,
    verticalAlign: 'middle',
    color: 'red'
  },
  warningIcon: {
    marginRight: 0,
    marginLeft: 0,
    verticalAlign: 'middle',
    color: 'orange'
  },
  toolbarStyle: {
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E5E5E5',
    minHeight: '54px',
    paddingTop: '0',
    paddingBottom: '0'
  },
  firstButtonStyle: {
    minHeight: '30px',
    padding: '5px 10px'
  },
  buttonStyle: {
    minHeight: '30px',
    padding: '5px 10px',
    marginRight: '10px'
  },
  root: {
    flexGrow: 1
  },
  barTitle: {
    flexGrow: 1,
    paddingLeft: '8px'
  },
  label: {
    paddingRight: '0px'
  },
  horisontalRule: {
    height: '1px',
    backgroundColor: '#E0E0E0',
    border: 'none'
  },
  ButtonMUISpan: {
    paddingLeft: '4px'
  },
  excelIcon: {
    verticalAlign: 'middle',
    paddingRight: '10px'
  },
  paperWidthFalse: {
    height: 'inherit',
    width: '100%'
  },
  leftWrapper: {
    flexGrow: 1
  },
  validateButton: {
    textAlign: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  circularProgress: {
    paddingRight: '3px'
  },
  validateButtonText: {
    color: 'grey'
  },
  validationColumn: {
    color: 'red'
  },
  validationColumnWarning: {
    color: 'orange'
  },
  noRows: {
    color: 'red'
  },
  tabsStyle: {
    color: 'black',
    background: 'transparent'
  },
  tableWrapper: {
    maxHeight: '70vh',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  },
  table: {
    overflow: 'auto',
    maxHeight: 'calc(100vh - 364px)',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  }
};

const AvatarImage = withStyles(styles)(({ classes, icon }) => {
  return <Avatar className={classes.avatar}>{icon}</Avatar>;
});

const ExcelIconImage = withStyles(styles)(({ classes, icon }) => {
  return <ExcelIcon className={classes.excelIcon}>{icon}</ExcelIcon>;
});

const ErrorImage = withStyles(styles)(({ classes, icon }) => {
  return <ErrorIcon className={classes.errorIcon}>{icon}</ErrorIcon>;
});

const StyledFileInput = withStyles({
  dropZone: {
    background: '#ffffff',
    border: '1px dashed #E0E0E0'
  },
  removeButton: {
    textAlign: 'center',
    padding: '.5rem'
  }
})(FileInput);

const ExcelInvestorTagImportTitleBarWithDropbox = withStyles(styles)(
  ({
    classes,
    type,
    title,
    createUrl,
    icon,
    hasExportInvestorTagExcelPermission,
    hasImportInvestorTagExcelPermission,
    hasCreatePermission,
    filters,
    investorTagNameFilter,
    selectedIds
  }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [importModelViewToggle, setsViewOfImport] = useState(false);
    const [validateButtonVisibile, setValidateButtonVisibility] = useState(
      false
    );
    const [submitting, setSubmitting] = useState(false);
    const [downloadingTemplate, setDownloadingTemplate] = useState(false);
    const [disableImportButton, setImportButtonDisabled] = useState(true);
    const [loaderVisible, setLoaderVisible] = useState(false);
    const [showGrid, setShowGrid] = useState(false);
    const [showNoDataInExcelError, setShowNoDataInExcelError] = useState(false);
    const [isFileFieldDisabled, setIsFileFieldDisabled] = useState(false);
    const [value, setValue] = useState('1');
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState(-1);
    const [response, setResponse] = useState('');
    const [responseTab2, setResponseTab2] = useState('');
    const [responseTab3, setResponseTab3] = useState('');
    const [tab1ContainsErrors, setTab1ContainsErrors] = useState(false);
    const [tab2ContainsErrors, setTab2ContainsErrors] = useState(false);
    const [tab3ContainsErrors, setTab3ContainsErrors] = useState(false);

    const [excelPayload, setExcelPayload] = useState(null);
    const notify = useNotify();
    const notifyServerError = useNotifyServerError();

    const handleClick = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleImportClick = () => {
      setAnchorEl(null);
      setsViewOfImport(true);
    };

    const handleCloseImportClick = () => {
      setAnchorEl(null);
      cleanUpData();
      setsViewOfImport(false);
    };

    const columnDirectionSort = (sortColumnName, isDesc) => {
      return function(a, b) {
        var x = a[sortColumnName]
          ? a[sortColumnName].toString().toLowerCase()
          : '';
        var y = b[sortColumnName]
          ? b[sortColumnName].toString().toLowerCase()
          : '';
        if (sortColumnName === 'rowNumber') {
          return isDesc ? x - y : y - x;
        }
        if (isDesc) {
          return x < y ? -1 : x > y ? 1 : 0;
        } else {
          return x < y ? 1 : x > y ? -1 : 0;
        }
      };
    };

    const handleRequestSort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowIndex';
          break;
        case 1:
          sortColumnName = 'tagName';
          break;
        case 2:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowIndex';
      }

      var sortedTableData = response.sort(
        columnDirectionSort(sortColumnName, isDesc)
      );

      setResponse(sortedTableData);
    };

    const handleRequestTab2Sort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowIndex';
          break;
        case 1:
          sortColumnName = 'investorId';
          break;
        case 2:
          sortColumnName = 'tagName';
          break;
        case 3:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowIndex';
      }

      var sortedTableData = responseTab2.sort(
        columnDirectionSort(sortColumnName, isDesc)
      );

      setResponse(sortedTableData);
    };

    const handleRequestTab3Sort = index => {
      const isDesc = order === 'desc';
      isDesc ? setOrder('asc') : setOrder('desc');
      setOrderBy(index);

      var sortColumnName;
      switch (index) {
        case 0:
          sortColumnName = 'rowIndex';
          break;
        case 1:
          sortColumnName = 'investorId';
          break;
        case 2:
          sortColumnName = 'tagName';
          break;
        case 3:
          sortColumnName = 'validationError';
          break;
        default:
          sortColumnName = 'rowIndex';
      }

      var sortedTableData = responseTab3.sort(
        columnDirectionSort(sortColumnName, isDesc)
      );

      setResponse(sortedTableData);
    };

    const cleanUpData = value => {
      setTab1ContainsErrors(false);
      setTab2ContainsErrors(false);
      setTab3ContainsErrors(false);
      setShowGrid(false);
      setImportButtonDisabled(true);
      if (value) {
        setValidateButtonVisibility(true);
      } else {
        setValidateButtonVisibility(false);
      }
    };

    function getExcelPayload(values) {
      const payload = new FormData();
      if (values.file) {
        payload.append('excelFile', values.file.rawFile, values.file.title);
      }
      return payload;
    }

    const handleClickValidation = async values => {
      const payload = getExcelPayload(values);

      setValidateButtonVisibility(false);
      setImportButtonDisabled(true);
      setLoaderVisible(true);
      setIsFileFieldDisabled(true);

      InvestorTagApi.validateImportFromExcel(payload)
        .then(responseData => {
          var arrayData = responseData['validatedAddNewInvestorTagImportDto'];
          setResponse(arrayData);

          var arrayDataTab2 =
            responseData['validatedAddInvestorTagAssociationImportDto'];
          setResponseTab2(arrayDataTab2);

          var arrayDataTab3 =
            responseData['validatedRemoveInvestorTagAssociationImportDto'];
          setResponseTab3(arrayDataTab3);

          const validationErrors = arrayData
            .slice(0)
            .filter(r => r.validationError !== '');
          setTab1ContainsErrors(validationErrors.length > 0);

          const validationErrorsTab2 = arrayDataTab2
            .slice(0)
            .filter(r => r.validationError !== '');
          setTab2ContainsErrors(validationErrorsTab2.length > 0);

          const validationErrorsTab3 = arrayDataTab3
            .slice(0)
            .filter(r => r.validationError !== '');
          setTab3ContainsErrors(validationErrorsTab3.length > 0);

          if (
            arrayData.length > 0 ||
            arrayDataTab2.length > 0 ||
            arrayDataTab3.length > 0
          ) {
            var errors = false;

            if (
              arrayData.length > 0 &&
              validationErrors &&
              validationErrors.length > 0
            ) {
              errors = true;
            }
            if (
              arrayDataTab2.length > 0 &&
              validationErrorsTab2 &&
              validationErrorsTab2.length > 0
            ) {
              errors = true;
            }
            if (
              arrayDataTab3.length > 0 &&
              validationErrorsTab3 &&
              validationErrorsTab3.length > 0
            ) {
              errors = true;
            }
            setImportButtonDisabled(errors);
          } else {
            setImportButtonDisabled(false);
            setShowNoDataInExcelError(false);
          }

          setLoaderVisible(false);
          setIsFileFieldDisabled(false);
          setShowGrid(true);
          setExcelPayload(payload);
        })
        .catch(e => {
          setExcelPayload(null);
          setLoaderVisible(false);
          setIsFileFieldDisabled(false);
          notify(getIcError(e), { type: 'error' });
        });
    };

    const handleImportInvestorTagClick = () => {
      if (!excelPayload) {
        setImportButtonDisabled(true);
        return;
      }
      setImportButtonDisabled(true);
      setLoaderVisible(true);
      setShowGrid(false);
      InvestorTagApi.importInvestorTagFromExcel(excelPayload)
        .then(() => {
          notify('ra.notification.custom_updated_message');
        })
        .catch(e => {
          setLoaderVisible(false);
          notifyServerError(e);
        })
        .finally(() => {
          setLoaderVisible(false);
          setsViewOfImport(false);
          handleCloseImportClick();
          refreshView();
        });
    };

    const handleTemplateDownload = () => {
      setDownloadingTemplate(true);
      InvestorTagApi.downloadInvestorTagImportTemplate()
        .then(resp => {
          const fileName = 'Investor Tag Import Template.xlsx';
          saveAs(resp, fileName);
        })
        .catch(e => {
          notifyServerError(e);
        })
        .finally(() => {
          setDownloadingTemplate(false);
        });
    };

    const handleExportClick = () => {
      setSubmitting(true);
      InvestorTagApi.exportInvestorTagToExcel(
        investorTagNameFilter,
        selectedIds
      )
        .then(resp => {
          const fileName = 'Investor Tags Export.xlsx';
          saveAs(resp, fileName);
          setSubmitting(false);
        })
        .catch(e => {
          notifyServerError(e);
          setSubmitting(false);
        });
    };

    return (
      <Toolbar className={classes.toolbarStyle}>
        <AvatarImage icon={icon} />
        <Typography
          style={{ fontSize: '20px', lineHeight: '28px' }}
          color="textPrimary"
          className={classes.barTitle}
        >
          {type}
        </Typography>
        {
          <div>
            {(hasImportInvestorTagExcelPermission ||
              hasExportInvestorTagExcelPermission) && (
              <ButtonMUI
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                <div className={classes.WrapperClass}>
                  <ExcelIconImage />
                  <span className={classes.ButtonMUISpan}>
                    Import/Export Investor Tags
                  </span>
                </div>
              </ButtonMUI>
            )}
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {hasImportInvestorTagExcelPermission && (
                <MenuItem onClick={handleImportClick}>
                  Import Investor Tags from Excel
                </MenuItem>
              )}
              {hasExportInvestorTagExcelPermission && (
                <MenuItem
                  onClick={() => handleExportClick()}
                  disabled={submitting}
                >
                  {submitting && (
                    <span className={classes.circularProgress}>
                      <CircularProgress size={'15px'} />
                    </span>
                  )}
                  Export Investor Tags to Excel
                </MenuItem>
              )}

              {hasImportInvestorTagExcelPermission && (
                <div>
                  <hr className={classes.horisontalRule} />
                  <MenuItem
                    onClick={handleTemplateDownload}
                    disabled={downloadingTemplate}
                  >
                    {downloadingTemplate && (
                      <span className={classes.circularProgress}>
                        <CircularProgress size={'15px'} />
                      </span>
                    )}
                    Download Template
                  </MenuItem>
                </div>
              )}
            </Menu>
          </div>
        }

        {hasCreatePermission && title && (
          <Button
            className={classes.firstButtonStyle}
            variant="contained"
            color="primary"
            href={createUrl}
          >
            {title}
          </Button>
        )}

        <Dialog
          open={importModelViewToggle}
          aria-label="Import Investors from Excel"
          maxWidth={false}
          onClose={reason => {
            if (reason === 'backdropClick') return null;
            if (reason === 'escapeKeyDown') return handleCloseImportClick();
          }}
          classes={{
            paperWidthFalse: classes.paperWidthFalse // class name, e.g. `classes-nesting-root-x`
          }}
        >
          <DialogTitleWithCloseButton onClose={handleCloseImportClick}>
            Import Investor Tags from Excel
          </DialogTitleWithCloseButton>

          <DialogContent>
            <div>
              <CustomSimpleForm
                toolbar={null}
                variant="standard"
                margin="normal"
              >
                <FormDataConsumer>
                  {({ formData, ...rest }) => (
                    <Grid>
                      {!isFileFieldDisabled && (
                        <StyledFileInput
                          source="file"
                          label="Import File"
                          accept={
                            'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                          }
                          placeholder="Drag and drop File Here or Upload"
                          variant="standard"
                          onChange={value => cleanUpData(value)}
                        >
                          <FileField
                            source="src"
                            title="title"
                            size="size"
                            type="type"
                          />
                        </StyledFileInput>
                      )}
                      {loaderVisible && <Loading />}

                      {validateButtonVisibile && (
                        <div className={classes.validateButton}>
                          <p className={classes.validateButtonText}>
                            No Data To Display
                            <br />
                            Click 'Validate' to parse and display Excel Data
                          </p>
                          <Button
                            onClick={() => handleClickValidation(formData)}
                            color="primary"
                            variant="contained"
                          >
                            Validate
                          </Button>
                        </div>
                      )}

                      {showGrid && (
                        <div className={classes.root}>
                          <TabContext value={value}>
                            <AppBar
                              position="static"
                              className={classes.tabsStyle}
                            >
                              <TabList aria-label="simple tabs example">
                                <Tab
                                  label="Add New Investor Tag"
                                  value="1"
                                  selectionFollowsFocus
                                  component={React.forwardRef(() => {
                                    return (
                                      <Button onClick={() => setValue('1')}>
                                        {tab1ContainsErrors && <ErrorImage />}
                                        Add New Investor Tag
                                      </Button>
                                    );
                                  })}
                                />
                                {/* evading console errors - should find a better way */}
                                <Tab
                                  label="Add Investor Tag Association"
                                  value="2"
                                  selectionFollowsFocus
                                  component={React.forwardRef(() => {
                                    return (
                                      <Button onClick={() => setValue('2')}>
                                        {tab2ContainsErrors && <ErrorImage />}
                                        Add Investor Tag Association
                                      </Button>
                                    );
                                  })}
                                />
                                {/* evading console errors - should find a better way */}
                                <Tab
                                  label="Remove Investor Tag Association"
                                  value="3"
                                  selectionFollowsFocus
                                  component={React.forwardRef(() => {
                                    return (
                                      <Button onClick={() => setValue('3')}>
                                        {tab3ContainsErrors && <ErrorImage />}
                                        Remove Investor Tag Association
                                      </Button>
                                    );
                                  })}
                                />
                              </TabList>
                            </AppBar>
                            <TabPanel value="1" selected={true}>
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Tag Name' },
                                        { id: 'Description' },
                                        { id: 'Validation Error' }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestSort(index)
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {response.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowIndex}</TableCell>
                                          <TableCell>{item.tagName}</TableCell>
                                          <TableCell>
                                            {item.description}
                                          </TableCell>
                                          <TableCell
                                            className={classes.validationColumn}
                                          >
                                            {item.validationError}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There is no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                            <TabPanel value="2">
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Investor ID' },
                                        { id: 'Investor Tag' },
                                        { id: 'Validation Error' }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestTab2Sort(index)
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {responseTab2.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowIndex}</TableCell>
                                          <TableCell>
                                            {item.investorId}
                                          </TableCell>
                                          <TableCell>{item.tagName}</TableCell>
                                          <TableCell
                                            className={classes.validationColumn}
                                          >
                                            {item.validationError}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                            <TabPanel value="3">
                              <div className={classes.tableWrapper}>
                                <Table
                                  stickyHeader
                                  aria-label="sticky table"
                                  size="small"
                                  className={classes.table}
                                >
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        { id: 'Row Number' },
                                        { id: 'Investor ID' },
                                        { id: 'Investor Tag' },
                                        { id: 'Validation Error' }
                                      ].map((headCell, index) => (
                                        <TableCell
                                          className={classes.cell}
                                          key={headCell.id}
                                          sortDirection={
                                            orderBy === index ? order : false
                                          }
                                        >
                                          <TableSortLabel
                                            active={orderBy === index}
                                            direction={order}
                                            onClick={() =>
                                              handleRequestTab3Sort(index)
                                            }
                                          >
                                            {headCell.id}
                                          </TableSortLabel>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {responseTab3.map((item, index) => {
                                      return (
                                        <TableRow key={index} hover>
                                          <TableCell>{item.rowIndex}</TableCell>
                                          <TableCell>
                                            {item.investorId}
                                          </TableCell>
                                          <TableCell>{item.tagName}</TableCell>
                                          <TableCell
                                            className={classes.validationColumn}
                                          >
                                            {item.validationError}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                              {showNoDataInExcelError && (
                                <span className={classes.noRows}>
                                  There are no data in excel file to be
                                  validated. Please, provide excel file with
                                  data.
                                </span>
                              )}
                            </TabPanel>
                          </TabContext>
                        </div>
                      )}
                    </Grid>
                  )}
                </FormDataConsumer>
              </CustomSimpleForm>
            </div>
          </DialogContent>
          <DialogActions style={{ borderTop: `1px solid rgba(0, 0, 0, 0.12)` }}>
            <div className={classes.leftWrapper}>
              <Button
                onClick={handleCloseImportClick}
                color="primary"
                variant="outlined"
                className={classes.button}
              >
                Close
              </Button>
            </div>
            <Button
              onClick={handleImportInvestorTagClick}
              color="primary"
              variant="contained"
              className={classes.button}
              disabled={disableImportButton}
            >
              Import
            </Button>
          </DialogActions>
        </Dialog>
      </Toolbar>
    );
  }
);

export default ExcelInvestorTagImportTitleBarWithDropbox;
